import type { CombinedError } from '@urql/core';

/**
 * A field missing from the schema root is what an `anonymous`-role response looks
 * like: Hasura validates the document against the role's schema and reports the
 * fields it cannot see.
 */
const MISSING_ROOT_FIELD =
  /field '.+' not found in type: '(query_root|mutation_root|subscription_root)'/;

const UNAUTHORIZED_STATUSES = [401, 403];

export function isPossibleAuthError(error: CombinedError): boolean {
  const status = (error.response as { status?: number } | undefined)?.status;

  if (status !== undefined && UNAUTHORIZED_STATUSES.includes(status))
    return true;

  return error.graphQLErrors.some((gqlError) => {
    const code = gqlError.extensions?.code;

    if (code === 'access-denied') return true;

    return (
      code === 'validation-failed' && MISSING_ROOT_FIELD.test(gqlError.message)
    );
  });
}
